import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Alert, Snackbar } from '@mui/material';
import {
  $messageHasSent,
  $showEnterMessageToApplicant,
  resetMessageHasSent,
  setShowEnterMessageToApplicant,
} from '../../../models/related-tickets';
import { SendDialog } from './sendDialog';

export const MessageToApplicant = () => {
  const { t } = useTranslation();
  const [showEnterMessageToApplicant, messageHasSent] = useUnit([
    $showEnterMessageToApplicant,
    $messageHasSent,
  ]);
  const [showSuccessSent, setShowSuccessSent] = useState(false);

  useEffect(() => {
    if (!messageHasSent) return;

    setShowSuccessSent(true);
    setShowEnterMessageToApplicant(false);
    resetMessageHasSent();
  }, [messageHasSent]);

  return (
    <>
      <Snackbar
        open={showSuccessSent}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        onClose={() => setShowSuccessSent(false)}
      >
        <Alert severity="success" variant="filled">
          {t('MessageHasBeenSent')}
        </Alert>
      </Snackbar>

      <SendDialog
        isOpen={showEnterMessageToApplicant}
        onClose={() => setShowEnterMessageToApplicant(false)}
      />
    </>
  );
};
